import React from "react";
import { Row, Col, Container } from "reactstrap";
import { connect } from "react-redux";
import Sidebar from "@/containers/Layout/sidebar";
import ClearPageLayout from "@/containers/Participant/components/ClearPageLayout";
import ClaimAwardsTable from "./components/ClaimAwardsTable";
import { useTranslation } from "react-i18next";

const Index = ({ template }) => {
  const { t } = useTranslation();

  if (template?.name === "clear") {
    return (
      <div className="claim-page">
        <div className="claim-page__header">
          <Container>
            <div className="claim-page__header-inner">
              <div>
                <h1 className="claim-page__title">{t("claim_awards")}</h1>
                <p className="claim-page__desc">{t("claim_award_desc")}</p>
              </div>
            </div>
          </Container>
        </div>

        <Container className="claim-page__body">
          <ClearPageLayout>
            <div className="claim-page__panel">
              <ClaimAwardsTable />
            </div>
          </ClearPageLayout>
        </Container>
      </div>
    );
  }

  return (
    <div className="m-4 mt-5">
      <Row>
        <Col md={4}>
          <Sidebar />
        </Col>
        <Col md={7} className="peer-peer">
          <div className="mb-5">
            <h4>{t("claim_awards")}</h4>
            <p className="text-justify">{t("claim_award_desc")}</p>
          </div>
          <ClaimAwardsTable />
        </Col>
      </Row>
    </div>
  );
};

export default connect((state) => ({ template: state.template }))(Index);
